import { render } from "./proCard.vue?vue&type=template&id=d0b516fc&scoped=true"
import script from "./proCard.vue?vue&type=script&lang=js"
export * from "./proCard.vue?vue&type=script&lang=js"

import "./proCard.vue?vue&type=style&index=0&id=d0b516fc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b516fc"]])

export default __exports__